import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/reset.jpg'
import _imports_1 from '@/assets/images/logo.svg'
import _imports_2 from '@/assets/images/white-logo.svg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "reset"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"d-inline-block mb-4\"><img src=\"" + _imports_1 + "\" class=\"rounded-3 for-light-logo\" alt=\"login\"><img src=\"" + _imports_2 + "\" class=\"rounded-3 for-dark-logo\" alt=\"login\"></div><h3 class=\"fs-28 mb-2\">Reset Password?</h3><p class=\"fw-medium fs-16 mb-4\"> Enter your new password and confirm it another time in the field below. </p>", 3)),
          _createElementVNode("form", null, [
            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"form-group mb-3\"><label class=\"label text-secondary\">Old Password</label><input type=\"password\" class=\"form-control\" placeholder=\"Type your old password\"></div><div class=\"form-group mb-3\"><label class=\"label text-secondary\">New Password</label><input type=\"password\" class=\"form-control\" placeholder=\"Type your new password\"></div><div class=\"form-group mb-3\"><label class=\"label text-secondary\">Confirm Password</label><input type=\"password\" class=\"form-control\" placeholder=\"Type your confirm password\"></div><div class=\"form-group mb-3\"><button type=\"submit\" class=\"btn btn-primary fw-medium py-2 px-3 w-100\"><div class=\"d-flex align-items-center justify-content-center py-1\"><i class=\"material-symbols-outlined text-white fs-20 me-2\"> autorenew </i><span>Send</span></div></button></div>", 4)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, [
                _cache[1] || (_cache[1] = _createTextVNode(" Back to ", -1)),
                _createVNode(_component_RouterLink, {
                  to: "/authentication/login",
                  class: "fw-medium text-primary text-decoration-none"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" Login ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}